import * as React from "react";
import Translate from '../../common/functions/translate';
import { Link } from "react-router-dom";
import AuthService from "../../services/authService";
import Spinner from '../../common/components/spinner/spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFolderOpen } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  history: any;
}

interface IState {
  isLoading: boolean;
  error: any;
  validationMessage: string;
}

class HomePageComponent extends React.Component<IProps, IState> {
  authService = new AuthService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      isLoading: false
    };
  }

  componentDidMount() {
    this.props.history.push('/offers/')
    // window.addEventListener('offline', () => {
    //   console.log('offline');
    // })
  }

  render() {
    const { isLoading } = this.state;
    return (
      <div>
        {isLoading ? <Spinner /> : null}

        <div className="dashboard">

          {this.authService.checkIsTrader() || this.authService.checkIsRegionalManager() ?
            <div className="p-col-12">
              <Link to="/offers/0">
                <div className="card summary">
                  <span className="title">{Translate("Creating")}</span>
                  <span className="detail">{Translate("Creating a new offer")}</span>
                  <span className="count new-offer"><FontAwesomeIcon icon={faPlus} /></span>
                </div>
              </Link>
              <Link to="/offers">
                <div className="card summary">
                  <span className="title">{Translate("Opening")}</span>
                  <span className="detail">{Translate("Opening an existing offer")}</span>
                  <span className="count existing-offer"><FontAwesomeIcon icon={faFolderOpen} /></span>
                </div>
              </Link>
            </div>
            : null}

        </div>
      </div >
    )
  }
}

export default HomePageComponent;